import { round } from './round'

export default function (divisible, divisor, precision = 2) {
  const result = round(divisible, precision) / round(divisor, precision) * 100
  return round(result, precision)
}
